export default __webpack_public_path__ + "static/media/soy.1840ce31.svg";